module.exports = __webpack_public_path__ + "static/media/auditoriumIpad.ddb7338d.png";